import { sumValues, throwTranslatableError } from '@/core';
import { updateTripOrdersRequest } from '../../requests';
import deepCopy from 'deepcopy';
import createTripOrder from './addOrderToTrip/createTripOrder';
import createSubOrderUpdate from './addOrderToTrip/createSubOrderUpdate';
import rdbClient from 'rdb-client';

export default async function addOrderToTrip({ dispatch }, { order, trip, despatchOption, deliveryOption, etd, eta, customDespatchParty, customDeliveryParty }) {
	if (!order || !trip) {
		throw new Error('failedToAddOrderToTrip');
	}

	if (!trip) {
		throw new Error('failedToAddOrderToTrip');
	}
	let tripClone = deepCopy(trip);
	
	// Remove order already on trip
	if (trip.orders && trip.orders.some(x => order.orderId === x.orderId)) {
		throw new Error ('orderAlreadyAdded');
	}

	// Date check?

	let loadingSeqNo = 0;
	if (trip.orders && trip.orders.length) {
		let maxLoadingSeqNo = trip.orders
			.reduce((acc, curr) => {

				if (curr.loadingSeqNo === undefined || curr.loadingSeqNo === null)
					return acc;

				if (acc > curr.loadingSeqNo)
					return acc;
				else
					return curr.loadingSeqNo;
			}, 0);

		loadingSeqNo = maxLoadingSeqNo + 1;
	}

	let newOrder = createTripOrder(order, trip, etd, eta, despatchOption, deliveryOption, customDespatchParty, customDeliveryParty, loadingSeqNo);
	let subOrderUpdates = [createSubOrderUpdate(newOrder)];
	

	// Add orders
	let addedOrders = [newOrder];
	let ordersList = trip.orders ? trip.orders.concat(addedOrders) : addedOrders;
	trip.volume = sumValues(ordersList, 'volume');
	trip.grossWeight = sumValues(ordersList, 'grossWeight');
	trip.loadingMeters = sumValues(ordersList, 'loadingMeters');

	try {
		let patch = rdbClient.createPatch(tripClone, trip);
		await updateTripOrdersRequest(trip.id, { tripPatches: patch, subOrderUpdates });
		dispatch('autoRefreshOrder');
	} catch (e) {
		throwTranslatableError(e, 'failedToAddOrderToTrip');
	}
	
}